import React, { useState } from 'react';
import {
  View,
  TextInput,
  StyleSheet,
  ActivityIndicator,
} from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { TaskStatusType, TASK_STATUS_CONFIG } from '@/types/admin/tasks';

interface QuickAddTaskProps {
  taskStatus: TaskStatusType;
  value: string;
  onValueChange: (value: string) => void;
  onSubmit: (title: string, status: TaskStatusType) => Promise<void>;
  onClear: () => void;
}

export const QuickAddTask: React.FC<QuickAddTaskProps> = ({
  taskStatus,
  value,
  onValueChange,
  onSubmit,
  onClear,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (loading) return;
    if (!value.trim()) return;

    try {
      setLoading(true);
      await onSubmit(value.trim(), taskStatus);
      onClear();
    } catch (error) {
      console.error('Failed to create task:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.inputContainer}>
        {loading && (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="small" color={ADMIN_COLORS.PRIMARY} />
          </View>
        )}
        <TextInput
          style={[styles.input, loading && styles.inputWithLoading]}
          value={value}
          onChangeText={onValueChange}
          onSubmitEditing={handleSubmit}
          placeholder={`Add task in ${TASK_STATUS_CONFIG[taskStatus].label}...`}
          placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
          editable={!loading}
          multiline={false}
          returnKeyType="done"
          blurOnSubmit={true}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  inputContainer: {
    position: 'relative',
  },
  input: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    paddingVertical: 12,
    paddingHorizontal: 0,
    fontStyle: 'italic',
  },
  inputWithLoading: {
    paddingLeft: 32,
  },
  loadingContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
  },
});
